import { render, staticRenderFns } from "./TerminalAnnouncements.vue?vue&type=template&id=278a6a36"
import script from "./TerminalAnnouncements.vue?vue&type=script&lang=js"
export * from "./TerminalAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./TerminalAnnouncements.vue?vue&type=style&index=0&id=278a6a36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports